import React, { useState, useEffect, useMemo } from 'react';
import { useTable } from 'react-table';
import Pagination from '../../shared/pagination/index';
import { RiDeleteBin5Line, RiPencilLine, RiAddFill } from "react-icons/ri";
import '../../../../src/index.css'; 
import { getScaleBrand, deleteScaleBrandId, createScaleBrand, updateScaleBrandId } from '../../../client/administration/scaleBrand/index';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";
import AddData from '../../shared/alertRegisterData/index';
import DeleteData from '../../shared/alertDeleteData/index';
import EditData from '../../shared/alertEditData/index';
import InputField from 'components/forms/inputField';

const TableScaleBrand = ({ recordsPerPage, data, currentPage, setCurrentPage, searchTerm, onSearchTermChange,  showModalAddScale, closeModalAddScale}) => {
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [scaleBrands, setScaleBrands] = useState([]);

  const totalRecords = scaleBrands.length;

  const [brandName, setBrandName] = useState('');
    
  const [showModalAddData, setShowModalAddData] = useState(false);

  const [editingScaleBrand, setEditingScaleBrand] = useState(null); 
  const [showEditConfirmModal, setShowEditConfirmModal] = useState(false);
  const [showModalEditScaleBrand, setShowModalEditScaleBrand] = useState(false); 

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [scaleBrandToDelete, setScaleBrandToDelete] = useState(null); 

  const [errors, setErrors] = useState({
    brandName: false,
  });

  useEffect(() => {
    const fetchScaleBrands = async () => {
      try {
        const { data } = await getScaleBrand();
        setScaleBrands(data);
      } catch (err) {
        setError(err.message || "Error al cargar los modelos");
      } finally {
        setLoading(false);
      }
    };

    fetchScaleBrands();
  }, []);

/************** FILTROS DE BUSQUEDA  *******************/

    useEffect(() => {
      const filteredData = data.filter(scaleBrand => {
/*
      const matchesBrandName = filterBrandName ? 
      scaleModel.scaleBrand && 
      scaleModel.scaleBrand.brandName && 
      scaleModel.scaleBrand.brandName.includes(filterBrandName) : true;
      
      const matchesModelName = filterModelName ? 
      scaleModel.modelName.toLowerCase().includes(filterModelName.toLowerCase()) : true;
*/
      const matchesSearchTerm = searchTerm ? 
      scaleBrand.brandName.toLowerCase().includes(searchTerm.toLowerCase())
      : true;

        return matchesSearchTerm
        ;
      });
  
      setScaleBrands(filteredData);
      setLoading(false);
    }, [data, searchTerm]); 
    

  /***AGREGAR REGISTRO*******/

  const handleSaveScaleBrand = async () => {

    const newErrors = {
      brandName: !brandName || brandName.length < 3 || brandName.length > 45,
    };


    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) {
      return;
    }

    const newScaleBrand = {
      brandName: brandName,
    };
   // console.log("Datos a enviar:", newScaleModel); // Esta línea imprime los datos en la consola

    try {
      const { data } = await createScaleBrand(newScaleBrand); 
      const {data: updatedScaleBrands} = await getScaleBrand();
      setScaleBrands(updatedScaleBrands)
      setBrandName('');
     // setShowModalAddScaleBrand(false);
      closeModalAddScale();
      setShowModalAddData(true);

      onSearchTermChange(searchTerm);
    } catch (err) {
     // setError("Error al agregar el modelo: " + err.message);
    }
  };

    /**EDITAR REGISTRO */
 const openModalEditScaleBrand = () => {
  setShowModalEditScaleBrand(true);
};

const closeModalEditScaleBrand = () => {
  setShowModalEditScaleBrand(false);
};
 const [editedScaleBrand, setEditedScaleBrand] = useState({
   id: '',
   brandName: '',
 });

 const handleEditClick = (row) => {
   setEditingScaleBrand(row);
   setEditedScaleBrand({
     id: row.original.id,
     brandName: row.original.brandName,
   });
 //  console.log(row.original);
 };


 const handleEditSubmit = async (e) => {
   e.preventDefault();
   const newErrors = {
    brandName: !editedScaleBrand.brandName || editedScaleBrand.brandName.length < 3 || editedScaleBrand.brandName.length > 45,
  };
  setErrors(newErrors);
  if (Object.values(newErrors).some(error => error)) {
      return;
  }
  
   setShowEditConfirmModal(true);
 };


/** ELIMINAR */

  const deleteScaleBrandHandler = (row) => {
  //  console.log("Registro seleccionado para eliminar:", row.original);
    setScaleBrandToDelete(row.original); 
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      if (!scaleBrandToDelete?.id) throw new Error("ID no encontrado");
      await deleteScaleBrandId(scaleBrandToDelete.id); // Usa el id para la eliminación en el backend
      setScaleBrands(prevData => prevData.filter(item => item.id !== scaleBrandToDelete.id)); // Actualiza la tabla localmente
      setShowDeleteModal(false); 
  } catch (error) {
      console.error("Error al eliminar:", error);
      //alert("No se pudo eliminar el registro.");
  }
  };
  

/**PAGINACION */

const totalPages = Math.ceil(totalRecords / recordsPerPage);

const changePage = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setCurrentPage(newPage);
  }
};

  /**COLUMNAS */
  const columns = useMemo(
    () => [
      { Header: 'ID', accessor: 'id', style: { width: '50px' } },
      { Header: 'Marca', accessor: 'brandName', style: { width: '260px' } },
      { Header: 'Fecha de registro', accessor: 'createdAt' ,  style: { width: '130px' } ,
      Cell: ({ value }) => {
        const date = new Date(value); 
        const formattedDate = date.toISOString().slice(0, 10); 
        const formattedTime = date.toTimeString().slice(0, 5); 
        return `${formattedDate} ${formattedTime}`;
      },},
      {
        Header: 'Editar',
        accessor: 'editar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => handleEditClick(row)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7]  hover:bg-[#D8D7E0]  rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiPencilLine className="text-xl text-black" />
            </button>
          </div>
        ),
      },
      {
        Header: 'Eliminar',
        accessor: 'eliminar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => deleteScaleBrandHandler(row)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7]  hover:bg-[#D8D7E0]  rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiDeleteBin5Line className="text-xl text-black" />
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const indexOfLastScaleBrand = currentPage * recordsPerPage;
  const indexOfFirstScaleBrand = indexOfLastScaleBrand - recordsPerPage;
  const currentScaleBrands = scaleBrands.slice(indexOfFirstScaleBrand, indexOfLastScaleBrand);


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data: currentScaleBrands,
      initialState: { pageIndex: 0, pageSize: recordsPerPage || 10 },
    },

  );

 //if (loading) return <p>Cargando datos...</p>;
 if (error) {
  return (
    <div className='items-center justify-center w-full min-h-full pt-16'>
      <p className='pt-4 text-2xl text-center text-error font-itcmedium'>
        Hubo un error al recuperar los datos.
      </p>
    </div>
  );
}


  return (
    <div className="w-full pt-4">
        {/**
        <button
          onClick={openModalAddScaleBrand}
          className="flex items-center justify-center h-[40px] p-3 px-5 mb-4 space-x-4 text-white rounded-md bg-green"
          >
          <RiAddFill className="flex text-[14px] font-itcmedium" /> 
          Agregar marca de balanza
        </button>
         */}

        {!error && scaleBrands.length === 0 && (
        <div className='flex items-center justify-center w-full'>
         <p className='pt-4 text-xl text-center font-itcmedium'>No se hallaron registros.</p>
        </div>
         )}

        {/* Modal de agregar */}
        {showModalAddScale && (
          <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
              <div className="flex justify-end">
                <button
                  onClick={closeModalAddScale}
                  className="px-1 py-0 rounded-md"
                >
                  <img src={buttonClose} alt="Cerrar"/>
                </button>
              </div>
              <div className="flex flex-col items-center justify-center px-4 pb-4 space-y-4">
                <div className="flex justify-center w-full">
                <h1 className="mb-4 text-2xl text-blue font-itcbold">Agregar marca de balanza</h1>
                </div>
                <div className="justify-center flex flex-col gap-4 w-[85%]">

                  <InputField
                    value={brandName}
                    placeholder="Nombre de la marca"
                    onChange={(e) => {
                      setBrandName(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, brandName: false }));
                    }}
                    error={errors.brandName}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                </div>
              </div>
              <div className="flex w-full py-4 pb-8 sm:px-[10%] justify-between gap-2">
              <button 
                  onClick={handleSaveScaleBrand}
                  className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi"
                >
                  Guardar
                </button>
                <button
                  onClick={closeModalAddScale}
                  className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de éxito */}
        {showModalAddData && (
          <AddData
            showModalAddData={showModalAddData}
            closeModalAddData={() => setShowModalAddData(false)}
          />
        )}

        {scaleBrands.length > 0 && (
          <>
            {/* Tabla de modelo de balanzas*/}
            <div className="overflow-x-auto max-w-screen scroll-container">
              <table {...getTableProps()} className="w-full border-collapse table-fixed">
                <thead className="bg-white">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()} className="text-sm text-center font-itcbold">
                      {headerGroup.headers.map(column => (
                        <th
                          {...column.getHeaderProps()}
                          style={column.style}
                          className="px-4 py-2 border border-[#D9D9D9]"
                        >
                          {column.render('Header')}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="table-row-group">
                  {rows.map(row => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        className={`text-sm border-collapse h-full font-itcmedium text-left ${row.index % 2 === 0 ? 'bg-white' : 'bg-[#EBEBEB]/[0.2]'}`}
                      >
                        {row.cells.map(cell => (
                          <td
                            {...cell.getCellProps()}
                            className="px-4 py-2 border border-[#D9D9D9]"
                          >
                            {cell.render('Cell')}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="flex flex-col items-center justify-between mt-6 space-x-4 space-y-2 md:flex-row">
            <p className="text-[#1F2A37] text-sm font-itcbook">
            Mostrando registros del {(currentPage - 1) * recordsPerPage + 1} al{' '}
              {Math.min(currentPage * recordsPerPage, totalRecords)} de un total de {totalRecords} registros

            </p>

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              changePage={changePage}
            />
            </div>
          </>
        )}


        {/* EDITAR REGISTRO */}
        {editingScaleBrand && (
          <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
                <button
                  onClick={closeModalEditScaleBrand}
                  className="px-1 py-0 rounded-md"
                >
                  <img src={buttonClose} alt="Cerrar"/>
                </button>
              </div>
              <div className='flex flex-col items-center justify-center px-4 pb-4 space-y-4'>
                <div className='flex justify-center w-full'>
                <h3 className="mb-4 text-2xl font-bold text-blue font-itcbold">Editar marca de balanza</h3>
                </div>
                <form onSubmit={handleEditSubmit} className=' w-[85%] justify-center' >
                  <div className='flex flex-col gap-4'>

                    <InputField
                      value={editedScaleBrand.brandName}
                      placeholder="Nombre de la marca"
                      onChange={(e) =>
                        setEditedScaleBrand((prevState) => ({
                          ...prevState,
                          brandName: e.target.value,
                        }))
                      }
                      error={errors.brandName}
                      errorMessage="Campo requerido"
                      minLength={3}
                      maxLength={45}
                      required
                    />

                  </div>
                  <div className="flex justify-between w-full gap-2 py-4 pt-8">
                      <button type="submit"
                      className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi">
                          Guardar
                      </button> 
                
                      <button type="button"
                        onClick={() => setEditingScaleBrand(null)}
                        className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                          Cancelar
                      </button>   
                    </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {showEditConfirmModal && (
            <EditData
                showModalEditData={showEditConfirmModal}
                closeModalEditData={() => setShowEditConfirmModal(false)}
                scalemodel={editedScaleBrand.brandName}
                onConfirm={async () => {
                    try {
                        await updateScaleBrandId(editedScaleBrand.id, {
                            brandName: editedScaleBrand.brandName,
                        });
                        const {data: updatedScaleBrand} = await getScaleBrand();
                        setScaleBrands(updatedScaleBrand);
                        setEditingScaleBrand(null);
                        setShowEditConfirmModal(false); 
                    } catch (err) {
                        setError("Error al actualizar el registro: " + err.message);
                    }
                }}
            />
        )}
        
        {/* Modal de eliminación */}
        {showDeleteModal && (
          <DeleteData
            showModalDeleteData={showDeleteModal}
            closeModalDeleteData={() => setShowDeleteModal(false)}
            scalemodel={scaleBrandToDelete?.brandName}
            confirmDelete={confirmDelete}
          />
        )}


    </div>
  );
};

export default TableScaleBrand;